/**
 * Moves an item within an array from one index to another.
 *
 * Creates a shallow copy of the input array and reorders
 * a single element without mutating the original array.
 *
 * @template T - Type of array elements
 * @param items - The source array
 * @param from - The index of the item to move
 * @param to - The target index where the item should be inserted
 * @returns A new array with the item moved to the new position
 */

export const moveItem = <T>(items: T[], from: number, to: number): T[] => {
  const updated = [...items];
  const [moved] = updated.splice(from, 1);

  if (!moved) return items;

  updated.splice(to, 0, moved);

  return updated;
};
